module.exports = __webpack_public_path__ + "img/dot-black.f194235e.svg";